var _defs, _path, _path2, _circle, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGestioneAccessi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 141.73 141.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{opacity:0.39;fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 34.92,
    y1: 81.13,
    x2: 92.14,
    y2: 81.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0ddea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6bcbd2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 34.92,
    y1: 82.48,
    x2: 73.28,
    y2: 82.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#47bdc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00737c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 46.58,
    y1: 34.82,
    x2: 80.49,
    y2: 34.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 11.42,
    y1: 97.96,
    x2: 130.31,
    y2: 97.96,
    xlinkHref: "#linear-gradient-2"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 4 copy 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.25,61.78,76.79,57a2.83,2.83,0,0,0-3.2.95L65.78,68.18a2.83,2.83,0,0,1-4.5,0l-7.91-10.3A2.86,2.86,0,0,0,50.16,57L36.79,61.78a2.83,2.83,0,0,0-1.87,2.66V86.6a18.87,18.87,0,0,0,18.87,18.87H73.28A18.86,18.86,0,0,0,92.14,86.6V64.46A2.83,2.83,0,0,0,90.25,61.78Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.79,105.47H73.28l-4.57-3.25A62.2,62.2,0,0,1,43.11,59.5h0l-6.32,2.28a2.83,2.83,0,0,0-1.87,2.66V86.6A18.87,18.87,0,0,0,53.79,105.47Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 63.53,
    cy: 34.82,
    r: 16.95
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M104.41,72.06a25.89,25.89,0,0,0-24.67,18H56L47.8,95.7l-8.71-5.62L30.75,95.7l-8.34-5.62-11,9.41,11.37,11.37H82a25.9,25.9,0,1,0,22.46-38.8Zm0,32.49A6.59,6.59,0,1,1,111,98,6.59,6.59,0,0,1,104.41,104.55Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestioneAccessi);
export default __webpack_public_path__ + "static/media/gestione-accessi.87380f60c2c8f8feb81e74f13692d037.svg";
export { ForwardRef as ReactComponent };